import React from 'react';
import { EMBEDDED_NOTEPAD_ACCESS_DENIED_MESSAGE } from './messages';

const EmbeddedNotepadAccessDenied = ({
  message = EMBEDDED_NOTEPAD_ACCESS_DENIED_MESSAGE,
}) => (
  <p className="text-sm text-gray-500">{message}</p>
);

export default EmbeddedNotepadAccessDenied;
